import { axiosInstanceMain } from "../../../utils/axiosGlobalUtils";
import { ITenant } from "../../AbmLocalPage/types";

export const getAllReportes = async (tenant: ITenant) => axiosInstanceMain.get(`admin/${tenant.path}/reportes`);

export const getInfoReporte = async (queryReporte: any, tenant: ITenant) =>
  axiosInstanceMain.get(`admin/${tenant.path}/reportes?reporte=${queryReporte}`);
